import styled from "styled-components";
import { Row as GlobalRow } from "styles";

export const Row = styled(GlobalRow)``;
